import React from "react";

const englishUsageOptions = [
  { value: "daily", label: "Setiap hari" },
  { value: "weekly", label: "Beberapa kali seminggu" },
  { value: "rarely", label: "Jarang" },
  { value: "never", label: "Hampir tidak pernah" },
];

const Step2 = ({ currentStep, totalSteps, answers, setAnswers, isPathB, onBack, onNext }) => {
  const scoreValue = answers.ieltsOverall || "";
  const parsedScore = Number.parseFloat(scoreValue);
  const isScoreValid = Number.isFinite(parsedScore) && parsedScore >= 0 && parsedScore <= 9;
  const canContinue = Boolean(isScoreValid && answers.englishUsageFrequency);

  return (
    <>
      <p className="st-font-body st-text-body-muted text-[14px] sm:text-[15px]">
        Step {currentStep} of {totalSteps}
      </p>

      <h1 className="st-font-body mt-1.5 text-[28px] font-bold leading-[1.15] text-[#212121] sm:text-[34px]">
        <span className="mr-2 inline-block h-2 w-2 rounded-full bg-[#BB230B] align-middle" />
        {isPathB ? "Skor placement kamu" : "Berapa skor IELTS kamu?"}
      </h1>
      <p className="st-font-body st-text-body-muted mt-1.5 text-[16px] sm:text-[18px]">
        {isPathB
          ? "Skor ini diambil dari hasil placement test dan dipakai sebagai acuan analisis kesiapanmu."
          : "Masukkan skor IELTS official kamu. Ini akan menjadi acuan utama analisis kesiapanmu!"}
      </p>

      <div className="mt-4 space-y-4">
        <div>
          <h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">Masukkan Skor IELTS overall</h2>
          <div className="mt-2">
            <input
              type="number"
              min="0"
              max="9"
              step="0.5"
              inputMode="decimal"
              value={scoreValue}
              readOnly={isPathB}
              onChange={(event) =>
                setAnswers((prev) => ({
                  ...prev,
                  ieltsOverall: event.target.value,
                }))
              }
              placeholder={isPathB ? "Skor dari placement" : "Contoh: 5.5"}
              className="st-focus-ring st-font-body st-readiness-select"
            />
          </div>
        </div>

        <div className="pt-2">
          <h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">
            Seberapa sering kamu pakai bahasa Inggris sehari-hari?
          </h2>
          <div className="mt-2 space-y-2">
            {englishUsageOptions.map((item) => (
              <button
                key={item.value}
                type="button"
                onClick={() =>
                  setAnswers((prev) => ({
                    ...prev,
                    englishUsageFrequency: item.value,
                  }))
                }
                className={`st-focus-ring st-font-body st-readiness-option ${
                  answers.englishUsageFrequency === item.value ? "st-readiness-option-active" : ""
                }`}
              >
                <span className="st-readiness-radio" aria-hidden="true" />
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-5 flex justify-between">
        <button type="button" className="st-focus-ring st-readiness-next" onClick={onBack}>
          ← Back
        </button>

        <button type="button" disabled={!canContinue} className="st-focus-ring st-readiness-next" onClick={onNext}>
          Next →
        </button>
      </div>
    </>
  );
};

export default Step2;
